import React from 'react';
import styled from 'styled-components';
import Image from 'components/Image';

interface Props {
    patron: Company;
    small?: boolean;
}

interface ImageContainerProps {
    small: boolean;
}

const ImageContainer = styled.div<ImageContainerProps>`
    border: 1px solid #b7cbd9 !important;
    max-width: 300px;
    max-height: 300px;
    margin: ${({ small }) => (small ? '0 auto' : '25px auto')};
`;

const CompanyImage = ({ patron, small = false }: Props): JSX.Element => (
    <ImageContainer small={small}>
        <Image type="logo" alt={patron.name} height={272} width={272} src={patron.logo} />
    </ImageContainer>
);

export default CompanyImage;
